<div class="d-flex justify-content-center">
  <div class="spinner-{{grow() ? 'grow' : 'border'}}"
       [class.spinner-border-sm]="!grow() && small()"
       [class.spinner-grow-sm]="grow() && small()"
       role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>
